import { Component, Input, OnInit, Injectable, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators  } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-iqacheading-create',
  templateUrl: './iqacheading-create.component.html',
  styleUrls: ['./iqacheading-create.component.scss']
})
export class IqacheadingCreateComponent implements OnInit {

  constructor(private http: HttpClient, private formBuilder: FormBuilder, @Inject('API_ENDPOINT') private api_endpoint: string, private ActivatedRoute: ActivatedRoute, private router: Router,) { }

  public Form: FormGroup;
  submitted = false;
  message = null;
  class = null;
  action = null;

  ngOnInit() {
    this.Form = this.formBuilder.group({
      heading: ['', Validators.required],
      _id: [''],
      seohidden: [''],
    });
    this.action = 'Submit';
    this.ActivatedRoute.params.subscribe(params => {
      let id = params['id'];
    this.http.get<any>(this.api_endpoint+'/iqacheadingbyid/' + `${id}`).subscribe(
        data => {
          if(data.data != null){
            this.action = 'Update';
            this.Form.patchValue({
              heading: data.data.heading,
              _id: data.data._id,
              seohidden:data.data.seohidden
            })
          }else{
            this.action = 'Submit';
            this.Form.patchValue({
              heading: '',
              _id: '',
            })
          }
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
    });
  });
  }

  get f() { return this.Form.controls; }

  onFormSubmit(action){
    console.log(this.Form.value);

    this.submitted = true;
    if(action == 'Update'){
      var data = {
        "heading"      : this.Form.value.heading,
        "admin" : sessionStorage.getItem('adminName'),
        "_id"           : this.Form.value._id,
        "seohidden": this.Form.value.seohidden
      };
      this.http.put<any>(this.api_endpoint+'/iqacheading', data).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Updated';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/iqacheading/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }else if(action == 'Submit'){
      var data1 = {
        "heading"      : this.Form.value.heading,
        "admin" : sessionStorage.getItem('adminName'),
        "seohidden": this.Form.value.seohidden
      };
      this.http.post<any>(this.api_endpoint+'/iqacheading', data1).subscribe(
        res => {
          console.log(res);
          if(res.Error){
            this.message = res.Error;
            this.class = 'btn btn-primary';
            return
          }else{
            this.message = 'Successfully Added';
            this.class = 'btn btn-success';
          } 
          this.router.navigateByUrl('/adminhkbkcms/iqacheading/list-page');
      },
      (err: HttpErrorResponse) => {
        if (err.error instanceof Error) {
          console.log("Client-side error occured.");
        } else {
          console.log("Server-side error occured.");
        }
      });
    }
  }

}
